module.exports = __webpack_public_path__ + "assets/img/00105.a49a8e7a.png";